import Store from "../wrappers/Store";
export default class Query {
    model;
    wheres;
    withs;
    order;
    /**
     * Create a new Query instance.
     */
    constructor(model) {
        this.model = model;
        this.wheres = [];
        this.withs = [];
        this.order = null;
    }
    $self() {
        return this.constructor;
    }
    where(field, value) {
        this.wheres.push({ field, value });
        return this;
    }
    with(name) {
        this.withs.push(name);
        return this;
    }
    orderBy(field, direction = 'asc') {
        this.order = { field, direction };
        return this;
    }
    get() {
        return this.select();
    }
    first() {
        const records = this.select();
        if (records.length === 0) {
            return undefined;
        }
        return records[0];
    }
    last() {
        const records = this.select();
        if (records.length === 0) {
            return undefined;
        }
        return records[records.length - 1];
    }
    find(value) {
        const records = this.select();
        if (records.length === 0) {
            return undefined;
        }
        return records.find(record => record[this.model.primaryKey] == value);
    }
    all() {
        return this.get();
    }
    /**
     * Process the query and filter data.
     */
    select() {
        // Get all record as an array and then start filtering it through.
        const ModelClass = this.model;
        let records = Store.models()?.all(ModelClass.entity) || [];
        // Let's filter the records at first by the where clauses.
        records = records.filter((record) => {
            for (let i = 0; i < this.wheres.length; i++) {
                const condition = this.wheres[i];
                if (record[condition.field] != condition.value) {
                    return false;
                }
            }
            return true;
        });
        // Load relations
        records = records.map((record) => {
            record.$load(this.withs);
            return record;
        });
        // Next, lets sort the data.
        if (this.order) {
            records = records.sort((a, b) => {
                if (!this.order?.field)
                    return 1;
                if (a[this.order?.field] < b[this.order?.field]) {
                    return this.order?.direction === 'desc' ? 1 : -1;
                }
                if (a[this.order?.field] > b[this.order?.field]) {
                    return this.order?.direction === 'desc' ? -1 : 1;
                }
                return 0;
            });
        }
        return records;
    }
}
//# sourceMappingURL=Query.js.map